import { render, staticRenderFns } from "./BioFields.vue?vue&type=template&id=277240ae&scoped=true"
import script from "./BioFields.vue?vue&type=script&lang=js"
export * from "./BioFields.vue?vue&type=script&lang=js"
import style0 from "./BioFields.vue?vue&type=style&index=0&id=277240ae&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "277240ae",
  null
  
)

export default component.exports